import type React from 'react'

// Login's stylesheet. Pure data, lifted out of the screen file so the
// component itself is navigable. No logic here.

export const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#06060c',
    padding: '2rem',
  },
  container: {
    width: '100%',
    maxWidth: '400px',
    background: '#121218',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
  },
  header: { marginBottom: '2rem' },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1.75rem',
  },
  subtitle: {
    fontSize: '26px',
    fontWeight: 650,
    color: 'var(--text-primary)',
    letterSpacing: '-0.03em',
    lineHeight: 1.2,
  },
  error: {
    background: 'var(--danger-subtle)',
    color: 'var(--danger)',
    padding: '0.6rem 0.75rem',
    borderRadius: 'var(--radius-md)',
    fontSize: '13px',
    marginBottom: '1rem',
  },
  infoBox: {
    background: 'rgba(34,197,94,0.1)',
    color: '#4ade80',
    padding: '0.6rem 0.75rem',
    borderRadius: 'var(--radius-md)',
    fontSize: '13px',
    marginBottom: '1rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
  },
  label: {
    fontSize: '13px',
    fontWeight: 500,
    color: 'var(--text-secondary)',
  },
  inputWrap: {
    position: 'relative' as const,
  },
  eyeBtn: {
    position: 'absolute' as const,
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: 1,
    padding: 0,
  },
  forgotLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    textAlign: 'right' as const,
    fontSize: '12px',
    color: 'var(--accent)',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  backLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    fontSize: '13px',
    color: 'var(--text-tertiary)',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'center' as const,
    marginTop: '4px',
  },
  input: {
    width: '100%',
    padding: '0.7rem 0.875rem',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '10px',
    fontSize: '15px',
    outline: 'none',
    background: '#1a1a24',
    color: 'var(--text-primary)',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    boxSizing: 'border-box' as const,
  },
  button: {
    width: '100%',
    padding: '13px',
    background: 'var(--accent)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: '0.5rem',
    boxShadow: '0 2px 12px rgba(251, 58, 174, 0.35)',
    transition: 'all 0.2s ease',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    margin: '1.25rem 0',
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    background: 'rgba(255,255,255,0.07)',
  },
  dividerText: {
    fontSize: '11px',
    color: 'var(--text-tertiary)',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.08em',
  },
  altButton: {
    width: '100%',
    padding: '12px',
    background: 'rgba(255,255,255,0.04)',
    color: 'var(--text-secondary)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s',
  },
}
